/** html2canvas 오프스크린 캡처용 — NEIS 연간·편제별 지도 계획 모달 테이블 */
export const NEIS_LEARNING_CONTENT_UPLOAD_CAPTURE_CSS = `
.cp-neis-learning-upload-export-subtitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 12px;
  margin: 0 0 6px;
  font-size: 20px !important;
  font-weight: 700;
  text-align: center;
  color: #111;
  line-height: 1.35 !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans KR', sans-serif;
}
.cp-neis-learning-upload-export-title {
  color: #111;
  font-size: 20px !important;
  line-height: 1.35 !important;
}
.cp-annual-cross-topic-detail-scope {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 17px !important;
  font-weight: 800;
  border: 1px solid transparent;
}
.cp-annual-cross-topic-detail-scope--term1 {
  background: #f3ecee;
  color: #4a383d;
  border-color: rgba(74, 56, 61, 0.22);
}
.cp-annual-cross-topic-detail-scope--term2 {
  background: #ebf0f4;
  color: #2c3a45;
  border-color: rgba(44, 58, 69, 0.22);
}
.cp-neis-learning-upload-table-wrap {
  width: 100%;
  overflow: visible;
}
.cp-neis-learning-upload-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 11px;
  line-height: 1.35;
  color: #111;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans KR', sans-serif;
}
.cp-neis-learning-upload-table th,
.cp-neis-learning-upload-table td {
  border: 1px solid #d8d8d8;
  padding: 5px 6px;
  word-break: break-word;
}
.cp-neis-learning-upload-table td {
  vertical-align: top;
}
.cp-neis-learning-upload-table th {
  background: #f4f4f4;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
}
.cp-neis-learning-upload-col-center {
  text-align: center;
  vertical-align: middle;
}
.cp-neis-learning-upload-th-stacked {
  white-space: normal;
  line-height: 1.15;
  padding: 4px 3px;
}
.cp-neis-learning-upload-th-line {
  display: block;
}
.cp-neis-learning-upload-period-value {
  display: block;
  width: 100%;
  text-align: center;
}
.cp-neis-learning-upload-learning {
  white-space: pre-wrap;
  text-align: left;
}
.cp-neis-learning-upload-col-narrow {
  padding-left: 4px;
  padding-right: 4px;
}
.cp-neis-learning-upload-table tbody tr:nth-child(even) td {
  background: #f8f8f8;
}
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) th:nth-child(1),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) td:nth-child(1) { width: 4%; }
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) th:nth-child(2),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) td:nth-child(2) { width: 6%; }
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) th:nth-child(3),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) td:nth-child(3) { width: 5%; }
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) th:nth-child(4),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) td:nth-child(4) { width: 8%; }
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) th:nth-child(5),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) td:nth-child(5) { width: 11%; }
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) th:nth-child(6),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) td:nth-child(6) { width: 28%; }
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) th:nth-child(7),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) td:nth-child(7),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) th:nth-child(8),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) td:nth-child(8) { width: 6%; text-align: center; }
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) th:nth-child(9),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) td:nth-child(9),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) th:nth-child(10),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) td:nth-child(10) { width: 4.5%; }
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) th:nth-child(11),
.cp-neis-learning-upload-table:not(.cp-neis-learning-upload-table--with-date) td:nth-child(11) { width: 11%; }
.cp-neis-learning-upload-table--with-date th:nth-child(1),
.cp-neis-learning-upload-table--with-date td:nth-child(1) { width: 3.5%; }
.cp-neis-learning-upload-table--with-date th:nth-child(2),
.cp-neis-learning-upload-table--with-date td:nth-child(2) { width: 7%; }
.cp-neis-learning-upload-table--with-date th:nth-child(3),
.cp-neis-learning-upload-table--with-date td:nth-child(3) { width: 3.5%; }
.cp-neis-learning-upload-table--with-date th:nth-child(4),
.cp-neis-learning-upload-table--with-date td:nth-child(4) { width: 4%; }
.cp-neis-learning-upload-table--with-date th:nth-child(5),
.cp-neis-learning-upload-table--with-date td:nth-child(5) { width: 5%; }
.cp-neis-learning-upload-table--with-date th:nth-child(6),
.cp-neis-learning-upload-table--with-date td:nth-child(6) { width: 4.5%; }
.cp-neis-learning-upload-table--with-date th:nth-child(7),
.cp-neis-learning-upload-table--with-date td:nth-child(7) { width: 7%; }
.cp-neis-learning-upload-table--with-date th:nth-child(8),
.cp-neis-learning-upload-table--with-date td:nth-child(8) { width: 9%; }
.cp-neis-learning-upload-table--with-date th:nth-child(9),
.cp-neis-learning-upload-table--with-date td:nth-child(9) { width: 22%; }
.cp-neis-learning-upload-table--with-date th:nth-child(10),
.cp-neis-learning-upload-table--with-date td:nth-child(10),
.cp-neis-learning-upload-table--with-date th:nth-child(11),
.cp-neis-learning-upload-table--with-date td:nth-child(11) { width: 5%; text-align: center; }
.cp-neis-learning-upload-table--with-date th:nth-child(12),
.cp-neis-learning-upload-table--with-date td:nth-child(12),
.cp-neis-learning-upload-table--with-date th:nth-child(13),
.cp-neis-learning-upload-table--with-date td:nth-child(13) { width: 4%; }
.cp-neis-learning-upload-table--with-date th:nth-child(14),
.cp-neis-learning-upload-table--with-date td:nth-child(14) { width: 9%; }
`;
